import React, { useCallback } from 'react'
import { FormattedHTMLMessage, Modal } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import Content from './Content'
import { lang } from './lang'
import { SettingsTabs } from './types'

interface Props {
    isOpen: boolean
    card?: GetCard
    onClose: () => void
}

function getTitle(tab: SettingsTabs) {
    if (tab === SettingsTabs.general) {
        return <FormattedHTMLMessage {...lang.titleGeneral} />
    }

    if (tab === SettingsTabs.pinTwoFa) {
        return <FormattedHTMLMessage {...lang.titlePinConfirm} />
    }

    if (tab.startsWith('threeDS')) {
        return <div />
    }

    return undefined
}

function onBackButtonClick(tab: SettingsTabs, setTab: (newTab: SettingsTabs) => void) {
    if (tab === SettingsTabs.threeDSGeneral) {
        return () => setTab(SettingsTabs.general)
    }

    if (
        tab === SettingsTabs.threeDSSms ||
        tab === SettingsTabs.threeDSEmail ||
        tab === SettingsTabs.threeDSBio ||
        tab === SettingsTabs.threeDSApproval ||
        tab === SettingsTabs.threeDSAbout ||
        tab === SettingsTabs.threeDSSecurity
    ) {
        return () => setTab(SettingsTabs.threeDSGeneral)
    }

    if (tab === SettingsTabs.threeDSQuestionFlow) {
        return () => setTab(SettingsTabs.threeDSSecurity)
    }

    return undefined
}

function SettingsModal({ isOpen, onClose, card }: Props) {
    const [tab, setTab] = React.useState<SettingsTabs>(SettingsTabs.general)

    const onCloseCb = useCallback(() => {
        onClose()
        setTab(SettingsTabs.general)
    }, [onClose])

    const showThreeDSBackButton = tab.startsWith('threeDS') && tab !== SettingsTabs.threeDSTwoFa

    return (
        <Modal
            title={getTitle(tab)}
            withHeaderBorder={
                tab === SettingsTabs.general || tab === SettingsTabs.pinTwoFa || tab === SettingsTabs.threeDSTwoFa
            }
            withBackButton={showThreeDSBackButton}
            onBackButtonClick={onBackButtonClick(tab, setTab)}
            onClose={onCloseCb}
            isOpen={isOpen}
            dataPointer="settings_modal"
            size="s"
            withTopPadding={!showThreeDSBackButton}
            withContentPaddings={
                tab !== SettingsTabs.general && tab !== SettingsTabs.threeDSGeneral && tab !== SettingsTabs.threeDSAbout
            }
            type="dialog"
            headerBackground={tab === SettingsTabs.threeDSAbout ? 'accent' : 'default'}
        >
            <Content onClose={onCloseCb} tab={tab} setTab={setTab} card={card} />
        </Modal>
    )
}

export default SettingsModal
